const gu = {
    global: {
        homeBreadcrumb: "ડેશબોર્ડ",
        searchLabel: "શોધો...",
        noRecordsToDisplayLabel: "કોઈ રેકોર્ડ મળ્યો નથી",
        rowsPerPageText: 'પ્રતિ પાનું પંક્તિઓ:', // Gujarati text for "Rows per page"
        rangeSeparatorText: 'માંથી', // Gujarati text for "of"
        selectAllRowsItem: true,
        selectAllRowsItemText: 'બધા પસંદ કરો', // Gujarati text for "All"
        selectUser: "વપરાશકર્તા પસંદ કરો",
        selectHead: "હેડ પસંદ કરો",
    },
    dashboard: {
      title: "ડેશબોર્ડ",
      homeBreadcrumb: "ડેશબોર્ડ",
      dashboardBreadcrumb: "ડેશબોર્ડ",
      headRegistrations: "હેડની નોંધણીઓ",
      users: "વપરાશકર્તાઓ",
      moreInfo: "વધુ માહિતી",
      totalGrants: "કુલ આવેલ ગ્રાન્ટ",
      totalUsedGrants: "કુલ વપરાયેલ ગ્રાન્ટ",
      totalRemainingGrants: "કુલ બંધ સિલક",
      approvalRequests: "કુલ મંજૂરી વિનંતીઓ",
    },
    sidebar: {
        dashboardLink: "ડેશબોર્ડ",
        headsLink: "હેડ અને ઓપનીંગ બેલેન્સ",
        ledgersLink: "રોજમેળ",
        reportsLink: "રિપોર્ટ્સ",
        extrasHeader: "વધુ",
        profileSettingsLink: "પ્રોફાઇલ અને સેટિંગ્સ",
        aboutUsDropdown: "અમારા વિશે",
        aboutEasyRojmelLink: "રોજમેલ વિશે",
        privacyPolicyLink: "ગોપનીયતા અને નીતિ",
        termsConditionsLink: "નિયમ અને શરતો",
        helpSupportDropdown: "મદદ અને સપોર્ટ",
        howToUseLink: "કેવી રીતે ઉપયોગ કરવો",
        callUsLink: "અમને કૉલ કરો",
        logoutLink: "લૉગ આઉટ",
        approvalRequests: "મંજૂરી વિનંતીઓ",
        users: "વપરાશકર્તાઓ",
    },
    footer: { // Added a 'footer' section in guLocale
        brandName: "Easy Rojmel", // Gujarati translation for "Easy Rojmel"
        rightsReserved: "All rights reserved.", // Gujarati translation for "All rights reserved."
        versionLabel: "Version", // Gujarati translation for "Version"
        versionNumber: "1.0", // Gujarati translation for "1.0" (using Gujarati numerals - optional)
        // If you prefer to keep "1.0" in English numerals, use: versionNumber: "1.0",
    },
    headListing: { // Added a 'headListing' section in guLocale
        title: "હેડ અને ઓપનીંગ બેલેન્સ", // Heads
        homeBreadcrumb: "ડેશબોર્ડ", // Home
        headsBreadcrumb: "હેડ અને ઓપનીંગ બેલેન્સ", // Heads
        noteLabel: "નોંધ", // Note:
        noteDescription: "હેડ અને ઓપનીંગ બેલેન્સ ઉમેરો",
        openingBalanceCash: "આ વર્ષ ની રોકડ ની ઓપનીંગ બેલેન્સ",
        openingBalanceBank: "આ વર્ષ ની બેક ની ઓપનીંગ બેલેન્સ",
        addHeadButtonText: "હેડ અને ઓપનીંગ બેલેન્સ ઉમેરો", // Add Head
        headName: "હેડ નું નામ",
        cashBalance: "રોકડ ની ઓપનીંગ બેલેન્સ",
        bankBalance: "બેંક ની ઓપનીંગ બેલેન્સ",
        action: "કાર્ય યોજના",
    },
    headModal: { // Added a 'headModal' section in guLocale
        editHeadModalTitle: "એકાઉન્ટ સંપાદિત કરો", // Edit Head
        addNewHeadsModalTitle: "નવા હેડ અને ઓપનીંગ બેલેન્સ ઉમેરો", // Add New Heads
        howManyHeadsLabel: "તમે કેટલા હેડ ઉમેરવા માંગો છો?", // How many heads do you want to create?
        enterNumHeadsPlaceholder: "હેડ ની સંખ્યા દાખલ કરો", // Enter number of heads
        addButtonText: "ઉમેરો", // Add
        headNameLabel: "હેડ નું નામ", // Head Name
        enterHeadNamePlaceholder: "હેડ નું નામ દાખલ કરો", // Enter head name
        headNameRequired: "હેડ નું નામ જરૂરી છે", // Head Name is required
        cashAmountLabel: "રોકડ ઓપનીંગ બેલેન્સ", // Cash Amount
        enterCashAmountPlaceholder: "રોકડ ઓપનીંગ બેલેન્સ દાખલ કરો", // Enter cash amount
        cashAmountRequired: "રોકડ ઓપનીંગ બેલેન્સ જરૂરી છે", // Cash Amount is required
        bankAmountLabel: "બેક ઓપનીંગ બેલેન્સ", // Bank Amount
        enterBankAmountPlaceholder: "બેક ઓપનીંગ બેલેન્સ દાખલ કરો", // Enter bank amount
        bankAmountRequired: "બેક ઓપનીંગ બેલેન્સ જરૂરી છે", // Bank Amount is required
        cancelButtonText: "રદ કરો", // Cancel
        submitButtonText: "સબમિટ કરો", // Submit
    },
    confirmationModal: { // Added a 'confirmationModal' section in guLocale
        defaultTitle: "ખાતરી કરો", // Confirm
        defaultMessage: "શું તમે ખાતરી કરો છો કે તમે ચાલુ રાખવા માંગો છો?", // Are you sure you want to continue?
        cancelButtonText: "રદ કરો", // Cancel
        confirmButtonText: "ખાતરી કરો", // Confirm
        deleteConfirmationTitle: "કાઢી નાખવાની ખાતરી કરો",
        deleteHeadConfirmationMessage: "શું તમે હેડ ડિલીટ કરવા માટે ખાતરી કરો છો? જો હા, તો તમામ હેડ સંબંધિત રોજમેળ એન્ટ્રી આપમેળે દૂર કરવામાં આવશે.",
        deleteLedgerConfirmationMessage: "શું તમે ખાતરી કરો છો કે તમે આ રોજમેળ એન્ટ્રી ડિલીટ કરવા માંગો છો?",
        approvalTitle: "મંજૂરી આપવા માટે ખાતરી કરો",
        approvalMessage: "શું તમે રોજમેળમાં ફેરફાર કરવાની વિનંતીને મંજૂરી આપવા માટે ખાતરી કરો છો?",
        rejectTitle: "માન્યતા ના આપવા માટે ખાતરી કરો",
        rejectMessage: "શું તમે રોજમેળમાં ફેરફાર કરવાની વિનંતીને માન્યતા ના આપવા માટે ખાતરી કરો છો?",
    },
    ledgerListing: { // Added a 'ledgerListing' section in guLocale
        title: "રોજમેળ", // Ledgers
        homeBreadcrumb: "ડેશબોર્ડ", // Home
        ledgersBreadcrumb: "રોજમેળ", // Ledgers
        totalGrants: "કુલ આવેલ ગ્રાન્ટ", // Total Grants
        totalUsedGrants: "કુલ વપરાયેલ ગ્રાન્ટ", // Total Used Grants
        totalRemainingGrants: "કુલ બંધ સિલક", // Total Remaining Grants
        addLedgerButtonText: "રોજમેળ ની એન્ટ્રી", // Add Ledger
        details: "આવક/જાવક વિગત",
        accountDetails: "તારીખ પ્રમાણે આવક/જાવક",
        amount: "રકમ",
        type: "આવક/જાવક",
        in: "આવક",
        out: "જાવક",
        action: "કાર્ય યોજના",
        paymentMethodCash: "રોકડ", // Cash
        paymentMethodCheque: "ચેક/PFMS", // Cheque
        paymentMethodOnline: "ઓનલાઈન/બેંક", // Online
    },
    ledgerViewModal: { // Added a 'ledgerViewModal' section in guLocale
        modalTitle: "રોજમેળની વિગતો જુઓ", // View Ledger Details
        transactionDateLabel: "તારીખ", // Transaction Date
        headNameLabel: "હેડનું નામ", // Head Name
        descriptionLabel: "કોને ચૂકવ્યા/ગ્રાન્ટ આવેલ તેની વિગત", // Description
        amountLabel: "રકમ", // Amount
        paymentMethodLabel: "ચુકવણી પદ્ધતિ", // Payment Method
        transactionTypeLabel: "પ્રકાર", // Transaction Type
        chequeVoucherNoLabel: "ચેક/વાઉચર નંબર.", // Cheque/Voucher No.
        chequeClearingDateLabel: "ચેક ક્લીયરિંગ તારીખ", // Cheque Clearing Date
        closeButtonText: "બંધ કરો", // Close
        paymentMethodCash: "રોકડ", // Cash
        paymentMethodCheque: "ચેક/PFMS", // Cheque
        paymentMethodOnline: "ઓનલાઈન/બેંક", // Online
        transactionTypeIn: "આવક", // IN
        transactionTypeOut: "જાવક", // OUT
    },
    ledgerModal: { // Added a 'ledgerModal' section in guLocale
        editLedgerModalTitle: "રોજમેળ સંપાદિત કરો", // Edit Ledger
        addLedgerModalTitle: "રોજમેળ એન્ટ્રી", // Add Ledger
        headLabel: "હેડ", // Head
        selectHead: "હેડ પસંદ કરો", // Select Head
        headRequired: "હેડ જરૂરી છે", // Head is required
        descriptionLabel: "કોને ચૂકવ્યા/ગ્રાન્ટ આવેલ તેની વિગત", // Description
        enterDescriptionPlaceholder: "ચૂકવ્યા/ગ્રાન્ટ આવેલ તેની વિગત દાખલ કરો", // Enter description
        detailsRequired: "કોને ચૂકવ્યા/ગ્રાન્ટ આવેલ તેની વિગત જરૂરી છે", // Details are required
        amountLabel: "રકમ", // Amount
        enterAmountPlaceholder: "રકમ દાખલ કરો", // Enter amount
        amountRequired: "રકમ જરૂરી છે", // Amount is required
        transactionDateLabel: "તારીખ", // Transaction Date
        selectDatePlaceholder: "તારીખ પસંદ કરો", // Select date
        transactionDateRequired: "તારીખ જરૂરી છે", // Transaction date is required
        transactionTypeLabel: "પ્રકાર", // Transaction Type
        selectTransactionType: "પ્રકાર પસંદ કરો", // Select Transaction Type
        transactionTypeRequired: "પ્રકાર જરૂરી છે", // Transaction type is required
        paymentMethodLabel: "ચુકવણી પદ્ધતિ", // Payment Method
        paymentMethodRequired: "ચુકવણી પદ્ધતિ જરૂરી છે", // Payment method is required
        paymentMethodCash: "રોકડ", // Cash
        paymentMethodCheque: "ચેક/PFMS", // Cheque
        paymentMethodOnline: "ઓનલાઈન/બેંક", // Online
        chequeNumberLabel: "ચેક/PFMS નંબર", // Cheque Number
        enterChequeNumberPlaceholder: "ચેક/PFMS નંબર દાખલ કરો", // Enter cheque number
        chequeNumberRequired: "ચેક/PFMS નંબર જરૂરી છે", // Cheque number is required
        chequePFMSClearingDateLabel: "ચેક/PFMS ક્લીયરિંગ તારીખ", // Cheque PFMS Clearing Date
        chequePFMSClearingDateRequired: "ચેક ક્લીયરિંગ તારીખ જરૂરી છે", // Cheque clearing date is required
        cancelButtonText: "રદ કરો", // Cancel
        submitButtonText: "સબમિટ કરો", // Submit
        transactionTypeIn: "આવક", // IN
        transactionTypeOut: "જાવક", // OUT
    },
    generateReport: {
        reportTypeCashbook: "કેશબુક",
        reportTypeAppendix9: "પરિશિષ્ટ-૯",
        reportTypeAppendix10: "પરિશિષ્ટ-૧૦",
        reportTypeKhatavahi: "ખાતાવહી",
        reportTypeBillRegister: "બિલ રજિસ્ટર",
        reportTypeGrantRegister: "ગ્રાન્ટ રજિસ્ટર",
        reportTypeChequeRegister: "ચેક રજિસ્ટર",
        selectReportType: "અહેવાલ પ્રકાર પસંદ કરો",
        selectHead: "હેડ પસંદ કરો",
        totalGrants: "કુલ આવેલ ગ્રાન્ટ",
        totalUsedGrants: "કુલ વપરાયેલ ગ્રાન્ટ",
        totalRemainingGrants: "કુલ બંધ સિલક",
        generatePDF: "PDF જનરેટ કરો",
        note: "નોંધ:",
        noteText: "અહીંથી તમે 7 પ્રકારના રિપોર્ટને ડાઉનલોડ કરી શકો છો. રિપોર્ટને ડાઉનલોડ કરવા નીચેના બટન પર ક્લિક કરો.",
        downloadReports: "અહેવાલ ડાઉનલોડ કરો",
        home: "ડેશબોર્ડ",
        reports: "અહેવાલ",
        pleaseSelectReportType: "મહેરબાની કરી અહેવાલ પ્રકાર પસંદ કરો.",
        pleaseEnterHeadId: "ખાતાવહી અહેવાલ માટે હેડ આઈડી દાખલ કરો.",
        reportGeneratedSuccess: "અહેવાલ સફળતાપૂર્વક જનરેટ થયો.",
        errorFetchingData: "ડેટા મેળવવામાં ભૂલ.",
    },
    cms: {
        home: "ડેશબોર્ડ",
        callUs: {
            title: "કોલ કરો",
            home: "ડેશબોર્ડ",
            callUsText: "અમને કોલ કરો +919723963863",
            whatsAppUsText: "અમને WhatsApp કરો +919723963863",
        },
        howToUse: {
            title: "કેવી રીતે ઉપયોગ કરવો",
            home: "ડેશબોર્ડ",
            videoTitle: "કેવી રીતે ઉપયોગ કરવો વિડિઓ",
        },
    },
    pricing: {
        subscribe: "ખરીદી કરો",
        alreadySubscribed: "ખરીદેલ યોજના",
        title: "તમારી યોજના પસંદ કરો",
        financialYear: "નાણાકીય વર્ષ",
    },
    profile: {
        title: "પ્રોફાઇલ",
        home: "ડેશબોર્ડ",
        // settingTab: "સેટિંગ્સ",
        settingTab: "નાણાકીય વર્ષ",
        financialYear: "વિત્તીય વર્ષ",
        plansTab: "યોજનાઓ",
        planHistory: "બિલિંગનો ઇતિહાસ",
        selectFinancialYear: "વિત્તીય વર્ષ પસંદ કરો",
        save: "સેવ કરો",
        fetchError: "પ્રોફાઇલ મેળવવામાં ભૂલ.",
        updateError: "પ્રોફાઇલ અપડેટ કરવામાં ભૂલ.",
        profileForm: {
            principle: "મુખ્યાધ્યાપક/ વોર્ડન/ સીઆરસી/ બીઆરસીનું પૂરું નામ",
            principlePlaceholder: "મુખ્યાધ્યાપક/ વોર્ડન/ સીઆરસી/ બીઆરસીનું પૂરું નામ દાખલ કરો",
            principleRequired: "મુખ્યાધ્યાપક/ વોર્ડન/ સીઆરસી/ બીઆરસીનું પૂરું નામ જરૂરી છે",
            schoolName: "શાળાનું નામ",
            schoolNamePlaceholder: "શાળાનું નામ દાખલ કરો",
            schoolNameRequired: "શાળાનું નામ જરૂરી છે",
            diceCode: "શાળા DISE કોડ",
            diceCodePlaceholder: "શાળા DISE કોડ દાખલ કરો",
            diceCodeRequired: "શાળા DISE કોડ જરૂરી છે",
            rojmelName: "રોજમેળનું નામ",
            rojmelNamePlaceholder: "રોજમેળનું નામ દાખલ કરો",
            rojmelNameRequired: "રોજમેળનું નામ જરૂરી છે",
            clusterName: "ક્લસ્ટરનું નામ",
            clusterNamePlaceholder: "ક્લસ્ટરનું નામ દાખલ કરો",
            clusterNameRequired: "ક્લસ્ટરનું નામ જરૂરી છે",
            blockName: "બ્લોકનું નામ",
            blockNamePlaceholder: "બ્લોકનું નામ દાખલ કરો",
            blockNameRequired: "બ્લોકનું નામ જરૂરી છે",
            bankName: "બેંકનું નામ",
            bankNamePlaceholder: "બેંકનું નામ દાખલ કરો",
            bankNameRequired: "બેંકનું નામ જરૂરી છે",
            branchName: "બેંક શાખાનું નામ",
            branchNamePlaceholder: "બેંક શાખાનું નામ દાખલ કરો",
            branchNameRequired: "બેંક શાખાનું નામ જરૂરી છે",
            bankAccountNumber: "બેંક એકાઉન્ટ નંબર",
            bankAccountNumberPlaceholder: "બેંક એકાઉન્ટ નંબર દાખલ કરો",
            bankAccountNumberRequired: "બેંક એકાઉન્ટ નંબર જરૂરી છે",
            address: "સરનામું",
            addressPlaceholder: "સરનામું દાખલ કરો",
            addressRequired: "સરનામું જરૂરી છે",
            district: "જિલ્લો",
            districtPlaceholder: "જિલ્લો દાખલ કરો",
            districtRequired: "જિલ્લો જરૂરી છે",
            subDivision: "તાલુકો",
            subDivisionPlaceholder: "તાલુકો દાખલ કરો",
            subDivisionRequired: "તાલુકો જરૂરી છે",
            pincode: "પિનકોડ",
            pincodePlaceholder: "પિનકોડ દાખલ કરો",
            pincodeRequired: "પિનકોડ જરૂરી છે",
            mobile: "મોબાઈલ",
            mobilePlaceholder: "મોબાઈલ નંબર દાખલ કરો",
            mobileRequired: "મોબાઈલ નંબર જરૂરી છે",
            mobileInvalid: "માન્ય 10-અંકનો મોબાઈલ નંબર દાખલ કરો",
            email: "બિઝનેસ ઈમેલ",
            emailPlaceholder: "બિઝનેસ ઈમેલ દાખલ કરો",
            emailRequired: "બિઝનેસ ઈમેલ જરૂરી છે",
            emailInvalid: "અમાન્ય ઈમેલ સરનામું",
            password: "પાસવર્ડ",
            passwordPlaceholder: "પાસવર્ડ દાખલ કરો",
            passwordRequired: "પાસવર્ડ જરૂરી છે",
            updateProfile: "પ્રોફાઇલ અપડેટ કરો",
        },
        settings: {
            financialYearLabel: "નાણાકીય વર્ષ", // Financial Year
            selectFinancialYear: "નાણાકીય વર્ષ પસંદ કરો", // Select Financial Year
            financialYearRequired: "નાણાકીય વર્ષ જરૂરી છે", // Financial Year is required
            saveButtonText: "સાચવો",
        },
        plans: {
            currentPlan: "હાલની યોજના", // Current Plan
            subscribe: "ખરીદી કરો", // Subscribe
            alreadySubscribed: "ખરીદેલ યોજના",
            billingHistory: "બિલિંગ ઇતિહાસ",
            title: "તમારી યોજનાઓ પસંદ કરો",
            srNo: "ક્રમ",
            planName: "યોજનાનું નામ",
            amount: "રકમ",
            description: "વિગત",
            planId: "પ્લાનની ID",
        },
    },
    admin: {
        approvalRequest: {
            approvalRequests: "મંજૂરી વિનંતીઓ",
            schoolName: "શાળાનું નામ",
            rojmelName: "રોજમેળનું નામ",
            headName: "હેડનું નામ",
            description: "વિગત",
            transactionDate: "વ્યવહાર તારીખ",
            type: "પ્રકાર",
            descriptions: "મંજૂરીની વિગતો",
            field: "લેબલ",
            before: "પહેલા",
            after: "પછી",
            homeBreadcrumb: "ડેશબોર્ડ",
            approveBtn: "મંજૂર કરો",
            rejectBtn: "નકારો",
        },
        ledger: {
            homeBreadcrumb: "ડેશબોર્ડ",
            title: "રોજમેળ",
        },
        head: {
            homeBreadcrumb: "ડેશબોર્ડ",
            title: "હેડ",
            aprilOpeningBalanceCashLabel: "આ વર્ષ ની રોકડ ની ઓપનીંગ બેલેન્સ",
            aprilOpeningBalanceBankLabel: "આ વર્ષ ની બેક ની ઓપનીંગ બેલેન્સ",
            headNameLabel: "હેડનું નામ"
        },
        user: {
            homeBreadcrumb: "ડેશબોર્ડ",
            users: "વપરાશકર્તાઓ",
            user: "વપરાશકર્તા",
            modalTitle: "વપરાશકર્તા વિગતો",
            brcFullNameLabel: "BRC/CRC/SMC/SMDC/KGBV",
            schoolNameLabel: "શાળાનું નામ",
            schoolDiceCodeLabel: "શાળા ડાઇસ કોડ",
            rojmelNameLabel: "રોજમેલનું નામ",
            clusterNameLabel: "ક્લસ્ટરનું નામ",
            blockNameLabel: "બ્લોકનું નામ",
            bankNameLabel: "બેંકનું નામ",
            bankBranchNameLabel: "બેંક શાખાનું નામ",
            bankAccountNoLabel: "બેંક ખાતા નંબર",
            addressLabel: "સરનામું",
            subDivisionLabel: "તાલુકો",
            districtLabel: "જિલ્લો",
            pincodeLabel: "પિનકોડ",
            mobileNoLabel: "મોબાઇલ નંબર",
            businessEmailLabel: "ઈમેઈલ",
            passwordLabel: "પાસવર્ડ",
            currentSubscriptionIdLabel: "વર્તમાન સબ્સ્ક્રિપ્શન ID",
            userRoleLabel: "વપરાશકર્તા ભૂમિકા",
            closeButtonText: "બંધ કરો",
            action: "કાર્ય યોજના",
            status: "સ્થિતિ",
            active: "સક્રિય",
            inactive: "નિષ્ક્રિય",
            view: "જુઓ",
            delete: "કાઢી નાંખો",
            user_success: "વપરાશકર્તા સફળતાપૂર્વક કરવામાં આવ્યો",
            are_you_sure_you_want_to_delete_user: "શું તમે ખરેખર આ વપરાશકર્તાને કાઢી નાંખવા માંગો છો?",
            delete_user: "વપરાશકર્તા કાઢી નાંખો",
            user_deleted_successfuly: "વપરાશકર્તા સફળતાપૂર્વક કાઢી નાંખવામાં આવ્યો છે",
        }
    },
    errorPages: {
        401: {
          headline: "401",
          title: "અનધિકૃત પ્રવેશ",
          description: "તમને આ પૃષ્ઠ જોવા માટે અનુમતિ નથી.",
          returnToDashboard: "ડેશબોર્ડ પર પાછા જાઓ",
        },
        404: {
          headline: "404",
          title: "પૃષ્ઠ મળ્યું નથી",
          description: "અમે જે પૃષ્ઠ તમે શોધી રહ્યા છો તે મળી શક્યું નથી.",
          returnToDashboard: "ડેશબોર્ડ પર પાછા જાઓ",
        },
        500: {
          headline: "500",
          title: "આંતરિક સર્વર ભૂલ",
          description: "અમે અત્યારે આ પૃષ્ઠ પ્રદર્શિત કરવામાં અસમર્થ છીએ.",
          returnToDashboard: "ડેશબોર્ડ પર પાછા જાઓ",
        },
    },
};

export default gu;